/////////////////////////////////////////////
// DEFAULT PROPS FOR COMPONENTS
/////////////////////////////////////////////

export const FONT_FAMILY = {
  heading: `"Amoresa", cursive`,
  subHeading: `"Cormorant SC", serif`,
  body: `"EB Garamond", serif`,
};

export const TEXT_PROPS = {
  heading: {
    fontFamily: 'heading',
    fontSize: 'heading',
    fontWeight: 'heading',
    fontStyle: 'var(--fontItalic-heading)',
    // lineHeight: '1.2',
    textAlign: 'center',
    color: 'alternativeColorText',
  },
  subHeading: {
    fontFamily: 'subHeading',
    fontSize: 'subHeading',
    fontWeight: 'subHeading',
    fontStyle: 'var(--fontItalic-subHeading)',
    // letterSpacing: '1.75px',
    textAlign: 'center',
    color: 'secondaryColorText',
  },
  body: {
    fontFamily: 'body',
    fontSize: 'body',
    fontWeight: 'body',
    fontStyle: 'var(--fontItalic-body)',
    color: 'mainColorText',
  },
  body_lv2: {
    fontFamily: 'body',
    fontSize: 'body_lv2',
    fontWeight: 'body_lv2',
    fontStyle: 'var(--fontItalic-body)',
    color: 'secondaryColorText',
    letterSpacing: '1px',
    textTransform: 'uppercase'
  },
};